import React from 'react';
import NextImage from 'next/image';
import { Mail, Mobile, Building } from '@solent-university/solent-icons';

import type { Props as LinkProps } from 'Elements/Link/Link';

import Grid, { Col } from 'Components/Grid';
import SocialIcons, { Props as SocialIconsProps } from 'Components/SocialIcons';

import defaultProfileImage from 'Public/images/cards/profile/default.png';

import {
    Container,
    Heading,
    JobTitle,
    Department,
    InformationContainer,
    ContactInformation,
    StyledIcon,
    SocialIconsWrapper,
    Link,
    ImageContainer,
    ImageWrapper,
    Wave
} from './Staff.styled';

export interface Props {
    firstName: string;
    lastName: string;
    honorific?: string;
    postNominalTitles?: string[];
    jobTitle: string;
    department?: string;
    email?: LinkProps;
    phone?: LinkProps;
    roomLocation?: string;
    image?: {
        src: string;
        alt?: string;
    };
    socialLinks?: SocialIconsProps;
}

const StaffProfile: React.FC<Props> = props => {
    const {
        firstName,
        lastName,
        honorific,
        postNominalTitles,
        jobTitle,
        department,
        email,
        phone,
        roomLocation,
        image,
        socialLinks
    } = props;

    return (
        <Container>
            <Grid>
                <Col s={8} m={6}>
                    <Heading>
                        {honorific} {firstName} {lastName} <br />
                        {postNominalTitles && postNominalTitles.join(', ')}
                    </Heading>
                    <JobTitle>{jobTitle}</JobTitle>
                    {department && <Department>{department}</Department>}
                    <InformationContainer>
                        {email && (
                            <ContactInformation>
                                <StyledIcon as={Mail} />
                                <Link {...email} openInNewTab={true} />
                            </ContactInformation>
                        )}
                        {phone && (
                            <ContactInformation>
                                <StyledIcon as={Mobile} />
                                <Link {...phone} openInNewTab={true} />
                            </ContactInformation>
                        )}
                        {roomLocation && (
                            <ContactInformation>
                                <StyledIcon as={Building} />
                                Room no. {roomLocation}
                            </ContactInformation>
                        )}
                        {socialLinks && (
                            <SocialIconsWrapper>
                                <SocialIcons {...socialLinks} />
                            </SocialIconsWrapper>
                        )}
                    </InformationContainer>
                </Col>
                <Col s={4} m={6}>
                    <ImageContainer>
                        <Wave />
                        <ImageWrapper>
                            <NextImage
                                src={image ? image.src : defaultProfileImage}
                                alt={image?.alt ? image.alt : `${firstName} ${lastName}`}
                                fill
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                            />
                        </ImageWrapper>
                    </ImageContainer>
                </Col>
            </Grid>
        </Container>
    );
};

export default StaffProfile;
